import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../constants';
import { Flex } from '../../grid';
import { Icon } from '../../icons';
import { P } from '../../typography/new';

const AutocompleteSuggestionWrapper = ({ handleBlur, children }) => {
  return (
    <DropdownContainer>
      <Flex justifyContent="space-between" alignItems="center" p="16px">
        <P variant="extra-small">Suggestions</P>
        <Flex as="button" title="Close" type="button" onClick={handleBlur} alignItems="center">
          <Icon name="cross" height="20px" width="20px" fill="black" />
        </Flex>
      </Flex>
      <Flex flexDirection="column" overflowY="auto" width="100%" px="16px">
        {children}
      </Flex>
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 250px;
  margin-top: 5px;
  background-color: ${colors.white};
  border-radius: 4px;
  z-index: 10;
`;

AutocompleteSuggestionWrapper.propTypes = {
  handleBlur: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export { AutocompleteSuggestionWrapper };
